export const deserialize = ({ position, ...node }) => ({
  ...node,
  children: [{ text: '' }],
});

export const serialize = ({ children, ...node }) => ({
  ...node,
  children: [],
});
